export default "__VITE_PUBLIC_ASSET__1e57df6f__"